/**
 * Internal AssetBee Configuration
 * Environment-aware API URLs for staging and production
 */

interface Config {
  assetbeeConfigUrl: string;
  pipesquidUrl: string;
  environment: 'production' | 'staging' | 'development';
}

function getConfig(): Config {
  // Determine environment from hostname
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  // Staging - staging-*.weretrade.com or staging.*.pages.dev
  if (hostname.startsWith('staging-') || hostname.startsWith('staging.')) {
    return {
      assetbeeConfigUrl: 'https://assetbee-config-staging.weretrade.workers.dev',
      pipesquidUrl: 'https://pipesquid-staging.weretrade.workers.dev',
      environment: 'staging',
    };
  }

  // Preview deployments (*.pages.dev but not staging/dev prefix)
  if (hostname.endsWith('.pages.dev')) {
    return {
      assetbeeConfigUrl: 'https://assetbee-config-production.weretrade.workers.dev',
      pipesquidUrl: 'https://pipesquid-production.weretrade.workers.dev',
      environment: 'production',
    };
  }

  // Production custom domains (*.weretrade.com)
  if (hostname.endsWith('.weretrade.com')) {
    return {
      assetbeeConfigUrl: 'https://assetbee-config-production.weretrade.workers.dev',
      pipesquidUrl: 'https://pipesquid-production.weretrade.workers.dev',
      environment: 'production',
    };
  }

  // Local development - use production URLs for testing
  return {
    assetbeeConfigUrl: 'https://assetbee-config-production.weretrade.workers.dev',
    pipesquidUrl: 'https://pipesquid-production.weretrade.workers.dev',
    environment: 'development',
  };
}

export const config = getConfig();

/* Schluessel der Einheit in design-system/v3/fleet-apps.json: Name, Marke und
   Art (`internal`) kommen von dort, ebenso `mcp: false` — assetBee hat keinen
   eigenen MCP-Server, FleetChrome setzt deshalb keinen MCP-Punkt. Derselbe
   Schluessel waehlt die GlyphField-Szene `assetBee:login` (GlyphLoader,
   GlyphErrorPage, ErrorBoundary). */
export const APP_KEY = 'assetBee';
